import clsx from "clsx";
import React from "react";
import _isNil from "lodash/isNil";
import { withStyles } from "@mui/styles";
import Brightness1 from "@mui/icons-material/Brightness1";
import CircularProgress from "@mui/material/CircularProgress";

import { styles } from "./styles";
import { getHealthCheckLevel } from "./helpers";
import { METRIC_TYPES } from "../../constants/global";
import Accordion from "../../components/Accordion/index";

const HealthAccordion = (props) => {
  const { children, classes, title, type, percentUptime, averageLatency } = props;

  const getSecondaryTitle = () => {
    if (_isNil(percentUptime) && type === METRIC_TYPES.CHECK_PASSED) return <CircularProgress size={14} />;
    if (_isNil(averageLatency) && type === METRIC_TYPES.REQUEST_LATENCY) return <CircularProgress size={14} />;

    const name = type === METRIC_TYPES.CHECK_PASSED ? "Percent Uptime" : "Average Latency";
    const value = type === METRIC_TYPES.CHECK_PASSED ? `${percentUptime}%` : `${averageLatency}ms`;
    const level = getHealthCheckLevel(percentUptime);

    return (
      <div className={classes.percent}>
        {type === METRIC_TYPES.CHECK_PASSED && (
          <Brightness1 className={clsx(classes[level], classes.healthCheckIcon)} />
        )}
        {name} &nbsp;<b>{value}</b>
      </div>
    );
  };

  return (
    <Accordion title={title} secondaryTitle={getSecondaryTitle()}>
      {children}
    </Accordion>
  );
};

export default withStyles(styles)(HealthAccordion);
